import { ICellRendererParams } from 'ag-grid-community'
import { User } from 'types'
import { PLACEHOLDER } from './common'

export const createdByRenderer = (props: ICellRendererParams<User>) => {
  const createdBy = props?.data?.creator
  const fullName = `${createdBy?.firstname} ${createdBy?.lastname}`

  if (createdBy === null || createdBy === undefined) {
    return PLACEHOLDER
  }

  return fullName
}
